import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import { Col, Modal, Row, SelectProps } from "antd";
import useGetFracoes from "core/features/fracao/hooks/useGetFracoes";
import colors from "core/resources/theme/colors";
import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import FormFracao from "./FormFracao";

export interface SelectFracaoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}

function SelectFracao({
  value,
  onChange,
  isInvalid,
  errorMessage,
  ...rest
}: SelectFracaoProps) {
  const { isLoading, isFetching, data, refetch } = useGetFracoes();
  const [fracaoEditId, setFracaoEditId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
      setFracaoEditId(undefined);
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (fracaoEditId) {
      setIsOpenModal(true);
    }
  }, [fracaoEditId]);

  return (
    <>
      <Modal
        centered
        visible={isOpenModal}
        footer={null}
        destroyOnClose
        onCancel={() => setIsOpenModal(false)}
        closable={false}
        width={"max(900px, 80vw)"}
        bodyStyle={{
          height: "max(95vh, 450px)",
          overflow: "auto",
          paddingBottom: 16,
        }}
      >
        <FormFracao
          fracaoEditId={fracaoEditId}
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSuccess={async (id) => {
            onChange(id);

            await refetch();

            setIsOpenModal(false);
          }}
        />
      </Modal>

      <Box as={Row} gutter={24} alignItems="center">
        <Col sm={19}>
          <SelectBaseAntd
            isInvalid={isInvalid}
            loading={isLoading || isFetching}
            size="large"
            placeholder="Selecione a fração"
            style={{ width: "100%", flexGrow: 1, flex: 1 }}
            value={value || undefined}
            onChange={onChange}
            {...rest}
            showSearch
            allowClear={false}
            searchValue={search}
            onSearch={(v) => {
              if (!isOpenModal) {
                setSearch(v);
              }
            }}
            optionFilterProp="label"
            options={data?.map((item) => ({
              value: item.id,
              label: item.nome,
            }))}
            notFoundContent={
              <Box>
                Nenhuma fração encontrada{" "}
                <Button
                  leftIcon={<i className="mdi mdi-plus" />}
                  size="xs"
                  colorScheme="orange"
                  onClick={() => setIsOpenModal(true)}
                >
                  cadastrar nova
                </Button>
              </Box>
            }
          />
        </Col>

        <Box as={Col} sm={5}>
          {!!value ? (
            <BiEdit
              color={colors.primary}
              size={24}
              onClick={() => setFracaoEditId(value)}
              cursor="pointer"
              aria-label="Editar fração"
              aria-roledescription="Botão de editar fração"
              style={{ marginTop: "auto", marginBottom: "auto" }}
            />
          ) : null}
        </Box>
      </Box>
    </>
  );
}

export default SelectFracao;
